<div class="spinner-overlay">
  <div class="spinner-container">
    <div class="loader-ring">
      <svg class="ring" viewBox="0 0 120 120" aria-hidden="true">
        <defs>
          <linearGradient
            id="spinnerRingGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop class="ring-stop-1" offset="0%" />
            <stop class="ring-stop-2" offset="55%" />
            <stop class="ring-stop-3" offset="100%" />
          </linearGradient>
        </defs>
        <circle class="ring-arc" cx="60" cy="60" r="48" />
      </svg>

      <svg class="loader-icon" viewBox="0 0 24 24" aria-hidden="true">
        <rect
          x="3"
          y="4"
          width="18"
          height="12"
          rx="1.6"
          stroke="currentColor"
          stroke-width="1.6"
          fill="none"
        />
        <path
          d="M9.5 20h5M12 16v4"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
        />
        <path
          d="M10.5 8.4 9 10l1.5 1.6M13.5 8.4 15 10l-1.5 1.6"
          stroke="currentColor"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
      </svg>
    </div>

    <p class="loading-title">{{ "common.loading.pleaseWait" | translate }}</p>
    <p class="loading-text">{{ spinnerService.message() | translate }}</p>

    <div class="loader-dots" aria-hidden="true">
      <span></span><span></span><span></span><span></span><span></span>
    </div>
  </div>
</div>
